import { styledThemed } from "../../../../../utils/styledThemed";

export const Logo = styledThemed.div<{ logo: string; invert?: boolean }>`
  width: 40px;
  height: 40px;
  margin: 0 20px 5px 0;
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  background-image: url(${(props) => props.logo});
  ${(props) => props.invert && "filter: invert(1);"}
  @media screen and (min-width: ${(props) => props.theme.xsmall}) {
    width: 60px;
    height: 60px;
    margin: 0 0 10px 0;
  }
`;

export const Text = styledThemed.div`
  font-weight: 500;
  font-size: 16px;
`;

export const Wrapper = styledThemed.div`
  display: flex;
  align-items: center;
  flex-direction: row;
  width: 100%;
  justify-content: flex-start;
  @media screen and (min-width: ${(props) => props.theme.xsmall}) {
    flex-direction: column;
    justify-content: center;
  }
`;
